import { priceField } from '../../../table/CommonFields';
import { roundHalfUp } from '../../../../helpers/numberUtils';

// Pola formularza
const fields = {
  config: { columns: 1 },
  fields: [
    {
      name: 'description',
      label: 'Opis opłaty',
      type: 'text',
      mandatory: true,
    },
    priceField(1, 'amount', 'Kwota', false),
  ],
};

export default fields;
